//INIT
import React, { useContext, useState } from "react"
import ServicosContext from "../../contexts/servicosContext"
import PinnDeliveryRepresentante from "../../functions/PinnDeliveryRepresentante"
import RepresentanteSelector from "../../functions/RepresentanteSelector"

//FUNCTIONS \ REQUESTS
import Cabecalho from "../Cabecalho"

//FILES

//IMPORTS
import AppBar from "@material-ui/core/AppBar"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import Container from "@material-ui/core/Container"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Fade from "@material-ui/core/Fade"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import Slide from "@material-ui/core/Slide"
import Snackbar from "@material-ui/core/Snackbar"
import { makeStyles } from "@material-ui/core/styles"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import CloseIcon from "@material-ui/icons/Close"
import MuiAlert from "@material-ui/lab/Alert"
import { Col, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
// import sistemaAdmGif from '../../assets/sistemaAdmGif.gif';
import CUSTOMER_ICON from "../../assets/icons/svg/012-customer.svg"
import {
    default as ACEITADOR_ICON,
    default as REGISTRADOR_ICON,
} from "../../assets/icons/svg/023-relation.svg"
import CAIXA_ICON from "../../assets/icons/svg/026-presentation.svg"
import ATENDENTE_ICON from "../../assets/icons/svg/028-online business.svg"
import SISTEMA_ADM_ICON from "../../assets/icons/svg/033-admin.svg"
import HOLDING from "../../assets/icons/svg/060-holding.svg"
import PEDIDO_MESA_ICON from "../../assets/icons/svg/064-flag.svg"
import Loading from "../Componentes/Loading"
import "./styles.css"

import { CardActionArea, Divider } from "@material-ui/core"
import useParametros from "../../contexts/ParametrosContext"
import useAppStore from "../../stores/AppStore"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const useStyles = makeStyles(theme => ({
    fixedImages: {
        position: "fixed",
        right: "2em",
        cursor: "pointer",
        bottom: "2em",
        width: "50px",
        height: "50px",
        zIndex: 1000,
        transition: "all .2s ease-in-out",
        "&:hover": {
            transform: "scale(1.2)",
        },
    },
    fixedQR: {
        position: "fixed",
        right: "2em",
        bottom: "7em",
        cursor: "pointer",
        width: "50px",
        height: "50px",
        zIndex: 1000,
        transition: "all .2s ease-in-out",
        "&:hover": {
            transform: "scale(1.2)",
        },
    },
    mainContainer: {
        padding: "3em 16px 48px 16px",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        minHeight: "100vh",
    },
    servicesGrid: {
        marginTop: theme.spacing(4),
        padding: theme.spacing(2),
    },
    serviceCard: {
        height: "100%",
        borderRadius: 16,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        background: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        overflow: "hidden",
        position: "relative",
        "&:hover": {
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
        },
    },
    cardContent: {
        padding: theme.spacing(3),
        height: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
    serviceIcon: {
        width: 64,
        height: 64,
        opacity: 0.8,
        transition: "all 0.3s ease",
        filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))",
    },
    serviceType: {
        fontSize: "0.75rem",
        fontWeight: 600,
        color: theme.palette.primary.main,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
    },
    serviceName: {
        fontSize: "1.25rem",
        fontWeight: 700,
        color: "#2c3e50",
        marginBottom: theme.spacing(1),
        lineHeight: 1.3,
    },
    serviceDescription: {
        fontSize: "0.875rem",
        color: "#64748b",
        lineHeight: 1.5,
        flex: 1,
        marginBottom: theme.spacing(1),
    },
    statusButton: {
        borderRadius: 25,
        padding: "8px 24px",
        fontSize: "0.75rem",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        border: "none",
        cursor: "pointer",
        transition: "all 0.3s ease",
        alignSelf: "flex-start",
        marginTop: "auto",
    },
    statusPermitido: {
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: "white",
        "&:hover": {
            background: "linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)",
            transform: "scale(1.05)",
        },
    },
    statusContratado: {
        background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
        color: "white",
        "&:hover": {
            background: "linear-gradient(135deg, #0f8a7c 0%, #32d96b 100%)",
            transform: "scale(1.05)",
        },
    },
    statusNaoPermitido: {
        background: "linear-gradient(135deg, #fc466b 0%, #3f5efb 100%)",
        color: "white",
        "&:hover": {
            background: "linear-gradient(135deg, #e03e59 0%, #3651e9 100%)",
            transform: "scale(1.05)",
        },
    },
    statusAtivo: {
        background: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
        color: "#8b4513",
        "&:hover": {
            background: "linear-gradient(135deg, #fde2c0 0%, #fa9e8d 100%)",
            transform: "scale(1.05)",
        },
    },
    helpIcon: {
        position: "absolute",
        top: 16,
        right: 16,
        color: "#f39c12",
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
            color: "#e67e22",
            transform: "scale(1.1)",
        },
    },
    // newBadge: {
    //     position: "absolute",
    //     top: -8,
    //     right: -8,
    //     background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
    //     color: "white",
    //     padding: "4px 12px",
    //     borderRadius: 12,
    //     fontSize: "0.7rem",
    //     fontWeight: 700,
    //     textTransform: "uppercase",
    //     letterSpacing: "0.5px",
    //     boxShadow: "0 4px 12px rgba(238, 90, 36, 0.3)",
    //     zIndex: 2,
    // },
    fadeIn: {
        animation: "$fadeInUp 0.6s ease-out",
    },
    "@keyframes fadeInUp": {
        "0%": {
            opacity: 0,
            transform: "translateY(30px)",
        },
        "100%": {
            opacity: 1,
            transform: "translateY(0)",
        },
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}))

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

export default function Servicos() {
    // Não está chegando aqui
    const history = useHistory()
    const classes = useStyles()
    const autorizacao = localStorage.getItem("chaveSistema")
    const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))
    const parametros = useParametros()

    const {
        handleRegistradorDePedidos,
        handleAceitadorDePedidos,
        handleSistemaAdm,
        handleCaixa,
        handleNotaFiscal,
        handleIzzaBot,
        handleCardapio,
        handlePedidoDeMesa,
        handleAreaDeEntrega,
        handleAgendamentoDeEntrega,
    } = useContext(ServicosContext)

    const configuracoes = useAppStore(s => s.configuracoes)

    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )

    const [help, setHelp] = React.useState({})
    const [loading, setLoading] = React.useState(false)
    const [contratar, setContratar] = React.useState("")
    const [alert, setAlert] = useState({ status: false, tipo: "success", mesangem: "" })

    const teste =
        window.location.hostname.includes("localhost") ||
        window.location.hostname.includes("192.168")

    const alertStart = (msg, tipo) => {
        setAlert({ status: true, tipo: tipo, mesangem: msg })
    }

    const alertClose = (event, reason) => {
        if (reason === "clickaway") {
            return
        }
        setAlert({ status: false, tipo: alert.tipo, mesangem: alert.mesangem })
    }

    const handleHelp = duvida => {
        setHelp(duvida)
    }
    const handleNotHelp = () => {
        setHelp({})
    }
    const servicosPainel = [
        {
            id: "SISTEMA_ADM",
            prioridade: 1,
            ativo: configuracoes.user?.perfil === "ADMINISTRADOR" ? "producao" : "escondido",
            permitido: configuracoes.user?.perfil === "ADMINISTRADOR" ? true : false,
            tipo: "Dashboard",
            icon: SISTEMA_ADM_ICON,
            nome: "Sistema Administrativo",
            descricaco: "Todas opções para configurações dos serviços.",
            funcao: handleSistemaAdm,
            tituloBotao:
                configuracoes.user?.perfil === "ADMINISTRADOR" ? "PERMITIDO" : "NÃO PERMITIDO",
            linkTutorial: [
                {
                    nome: "",
                    url: "https://www.youtube.com/embed/s787GjWQiWk",
                },
            ],
        },
        {
            id: "ACEITADOR",
            prioridade: 10,
            ativo: "producao",
            tipo: "Módulo",
            permitido: true,
            icon: ACEITADOR_ICON,
            nome: "Painel de Pedidos",
            descricaco: "Aceite e controle todos os pedidos.",
            funcao: handleAceitadorDePedidos,
            tituloBotao: "CONTRATADO",
            linkTutorial: [
                {
                    nome: "Recebedor de Pedidos",
                    url: "https://www.youtube.com/embed/videoseries?list=PLoSjpDNeiAff5Y9-3kaNTUCppseUoPQjx",
                },
            ],
        },
        {
            id: "REGISTRADOR",
            prioridade: 11,
            ativo: "producao",
            tipo: "Módulo",
            permitido: configuracoes.user?.parametros.exibirRegistroPedidos ? true : false,
            icon: REGISTRADOR_ICON,
            nome: "Registrador de Pedidos",
            descricaco: "Registre os pedidos de telefone, whatsapp e mesa.",
            funcao: handleRegistradorDePedidos,
            tituloBotao: configuracoes.user?.parametros.exibirRegistroPedidos
                ? "CONTRATADO"
                : "CONTRATAR",
            linkTutorial: [
                {
                    nome: "Registrador de Pedidos",
                    url: "https://www.youtube.com/embed/videoseries?list=PLoSjpDNeiAfcTvx_TpXJyfEPWwrcUo9cd",
                },
            ],
        },
        {
            id: "PEDIDO_MESA",
            prioridade: 11,
            ativo: "producao",
            tipo: "Módulo",
            permitido: configuracoes.user?.parametros.possuiModuloPedidosMesa ? true : false,
            icon: PEDIDO_MESA_ICON,
            nome: "Pedido de Mesa",
            descricaco: "Gere QRCode para seu cliente realizar pedidos da mesa.",
            funcao: handlePedidoDeMesa,
            tituloBotao: configuracoes.user?.parametros.possuiModuloPedidosMesa
                ? "PERMITIDO"
                : "CONTRATAR",
            linkTutorial: [
                {
                    nome: "Cliente Usando o Pedido pela Mesa",
                    url: "https://www.youtube.com/embed/FuXsc0jPA7M",
                },
            ],
        },

        {
            id: "CAIXA",
            prioridade: 11,
            ativo: "producao",
            tipo: "Módulo",
            permitido: true,
            dataLancamento: new Date("May 03 2021"),
            icon: CAIXA_ICON,
            nome: "Caixa",
            descricaco: "Controle seu caixa pela direto pela plataforma.",
            funcao: handleCaixa,
            tituloBotao: "ACESSAR",
            linkTutorial: [
                {
                    nome: "Módulo Caixa",
                    url: "https://www.youtube.com/embed/wATpnowNTAg",
                },
            ],
        },
        {
            id: "NOTA_FISCAL",
            prioridade: 11,
            ativo: "teste",
            tipo: "Módulo",
            permitido: true,
            icon: ATENDENTE_ICON,
            nome: "Nota Fiscal",
            descricaco: "Descrição",
            funcao: handleNotaFiscal,
            tituloBotao: "CONTRATADO",
            linkTutorial: [],
        },
        {
            id: "CARDAPIO",
            ativo: "producao",
            prioridade: 21,
            tipo: "Módulo",
            permitido: true,
            icon: HOLDING,
            nome: "Cardápio",
            descricaco: "Edite o seu cardápio.",
            funcao: handleCardapio,
            tituloBotao: "ATIVO",
            linkTutorial: [],
        },
        {
            id: "AREADEENTREGA",
            ativo: configuracoes.user?.parametros.calculoEntrega === 2 ? "producao" : "teste",
            prioridade: 22,
            tipo: "Módulo",
            permitido: true,
            icon: CUSTOMER_ICON,
            nome: "Área de entrega",
            descricaco: "Edite suas áreas de entrega",
            funcao: handleAreaDeEntrega,
            tituloBotao: "ATIVO",
            linkTutorial: [],
        },
        {
            id: "IZZA_BOT",
            prioridade: 20,
            ativo: "producao",
            tipo: "Módulo",
            permitido: configuracoes.user?.parametros.modoIzza ? true : false,
            icon: ATENDENTE_ICON,
            nome: "Atendente Virtual de Whatsapp",
            descricaco: "Deixe que a Atendente Virtual atenda seus clientes.",
            funcao: handleIzzaBot,
            tituloBotao: configuracoes.user?.parametros.modoIzza ? "CONTRATADO" : "CONTRATAR",
            linkTutorial: [
                {
                    nome: "Cliente Usando o Pedido pelo Whatsapp",
                    url: "https://www.youtube.com/embed/TAyh0IBVTLk",
                },
            ],
        },
        {
            id: "CONVERSAS_WHATSAPP",
            prioridade: 23,
            ativo:
                configuracoes.user?.perfil === "WHATSAPP" ||
                configuracoes.user?.perfil === "CLIENTEFIEL"
                    ? "producao"
                    : "escondido",
            tipo: "Ferramenta",
            permitido:
                configuracoes.user?.perfil === "WHATSAPP" ||
                configuracoes.user?.perfil === "CLIENTEFIEL",
            icon: ATENDENTE_ICON,
            nome:
                configuracoes.user?.perfil === "WHATSAPP"
                    ? "Chat"
                    : "Conversas WhatsApp",
            descricaco: "Acesse as conversas do WhatsApp.",
            funcao: () => {
                localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
                history.push("/servicos/modulo/conversas-whatsapp")
            },
            tituloBotao:
                configuracoes.user?.perfil === "WHATSAPP" ||
                configuracoes.user?.perfil === "CLIENTEFIEL"
                    ? "ACESSAR"
                    : "NÃO PERMITIDO",
            linkTutorial: [],
        },
        {
            id: "CRIAR_TEMPLATE_WHATSAPP",
            prioridade: 24,
            ativo:
                configuracoes.user?.perfil === "CLIENTEFIEL" ||
                configuracoes.user?.perfil === "WHATSAPP"
                    ? "producao"
                    : "escondido",
            tipo: "Ferramenta",
            permitido:
                configuracoes.user?.perfil === "CLIENTEFIEL" ||
                configuracoes.user?.perfil === "WHATSAPP",
            icon: ATENDENTE_ICON,
            nome:
                configuracoes.user?.perfil === "WHATSAPP"
                    ? "Cadastrar templates"
                    : "Criar template WhatsApp",
            descricaco: "Cadastre novos modelos de mensagem na conta WhatsApp Business (Graph API).",
            funcao: () => {
                localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
                history.push("/servicos/modulo/criar-template-whatsapp")
            },
            tituloBotao:
                configuracoes.user?.perfil === "CLIENTEFIEL" ||
                configuracoes.user?.perfil === "WHATSAPP"
                    ? "ACESSAR"
                    : "NÃO PERMITIDO",
            linkTutorial: [],
        },
        {
            id: "ENVIO_TEMPLATE_GRUPO_WHATSAPP",
            prioridade: 25,
            ativo:
                configuracoes.user?.perfil === "CLIENTEFIEL" ||
                configuracoes.user?.perfil === "WHATSAPP"
                    ? "producao"
                    : "escondido",
            tipo: "Ferramenta",
            permitido:
                configuracoes.user?.perfil === "CLIENTEFIEL" ||
                configuracoes.user?.perfil === "WHATSAPP",
            icon: ATENDENTE_ICON,
            nome:
                configuracoes.user?.perfil === "WHATSAPP"
                    ? "Disparar templates"
                    : "Envio template WhatsApp (grupo)",
            descricaco: "Dispare o template aprovado para uma lista de telefones (um por linha).",
            funcao: () => {
                localStorage.setItem("dataUltimoServico", JSON.stringify({ data: new Date() }))
                history.push("/servicos/modulo/envio-template-whatsapp-grupo")
            },
            tituloBotao:
                configuracoes.user?.perfil === "CLIENTEFIEL" ||
                configuracoes.user?.perfil === "WHATSAPP"
                    ? "ACESSAR"
                    : "NÃO PERMITIDO",
            linkTutorial: [],
        },
    ]

    const pegarStatusClass = tituloBotao => {
        switch (tituloBotao) {
            case "PERMITIDO":
                return classes.statusPermitido
            case "CONTRATADO":
                return classes.statusContratado
            case "NÃO PERMITIDO":
            case "CONTRATAR":
                return classes.statusNaoPermitido
            case "ATIVO":
            case "ACESSAR":
                return classes.statusAtivo
            default:
                return classes.statusAtivo
        }
    }

    return (
        <Box className={classes.mainContainer} style={{ marginLeft: mobile ? "" : "80px" }}>
            <Cabecalho
                pagina={configuracoes.user?.usuario}
                subtitulo={" - " + configuracoes.user?.perfil}
                cor={"#464646"}
                icone={
                    configuracoes.user?.parametros.estabelecimento?.urlLogo
                        ? configuracoes.user?.parametros.estabelecimento?.urlLogo
                        : aplicativoDados.urlLogo
                }
                voltar={false}
            />

            <Loading />

            <Snackbar open={alert.status} autoHideDuration={6000} onClose={alertClose}>
                <Alert onClose={alertClose} severity={alert.tipo}>
                    {alert.mesangem}
                </Alert>
            </Snackbar>

            <Container maxWidth="xl" className={classes.servicesGrid}>
                <Grid container spacing={3} justifyContent="center">
                    {servicosPainel
                        .filter(servicoPainel => {
                            const perfilPainel = configuracoes.user?.perfil
                            if (perfilPainel === "WHATSAPP") {
                                return [
                                    "CONVERSAS_WHATSAPP",
                                    "CRIAR_TEMPLATE_WHATSAPP",
                                    "ENVIO_TEMPLATE_GRUPO_WHATSAPP",
                                ].includes(servicoPainel.id)
                            }
                            if (
                                servicoPainel.id === "CONVERSAS_WHATSAPP" &&
                                perfilPainel !== "CLIENTEFIEL" &&
                                perfilPainel !== "WHATSAPP"
                            ) {
                                return false
                            }
                            if (
                                (servicoPainel.id === "ENVIO_TEMPLATE_GRUPO_WHATSAPP" ||
                                    servicoPainel.id === "CRIAR_TEMPLATE_WHATSAPP") &&
                                perfilPainel !== "CLIENTEFIEL" &&
                                perfilPainel !== "WHATSAPP"
                            ) {
                                return false
                            }

                            //limita o que deve aparecer no painel Pinn
                            const representanteIdentifier =
                                RepresentanteSelector.getRepresentante().getIdentifier()
                            const pinnIdentifier = PinnDeliveryRepresentante.getIdentifier()
                            const isPinnDelivery = representanteIdentifier === pinnIdentifier

                            const paineisAceitos = ["SISTEMA_ADM", "ACEITADOR", "REGISTRADOR"]
                            if (isPinnDelivery && perfilPainel !== "CLIENTEFIEL") {
                                return paineisAceitos.includes(servicoPainel.id)
                            }

                            return true
                        })
                        .map(
                            (servicoPainel, index) =>
                                (servicoPainel.ativo === "producao" || teste) && (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                        <Fade in={true} timeout={600 + index * 100}>
                                            <Card
                                                className={`${classes.serviceCard} ${classes.fadeIn}`}
                                                style={{ animationDelay: `${index * 100}ms` }}
                                            >
                                                <CardActionArea
                                                    onClick={() => servicoPainel.funcao()}
                                                    style={{ height: "100%" }}
                                                >
                                                    <Box className={classes.cardContent}>
                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            mb={2}
                                                        >
                                                            <img
                                                                src={servicoPainel.icon}
                                                                alt={servicoPainel.id}
                                                                className={classes.serviceIcon}
                                                            />
                                                        </Box>

                                                        <Typography className={classes.serviceType}>
                                                            {servicoPainel.tipo}
                                                        </Typography>

                                                        <Typography className={classes.serviceName}>
                                                            {servicoPainel.nome}
                                                        </Typography>

                                                        <Typography
                                                            className={classes.serviceDescription}
                                                        >
                                                            {servicoPainel.descricaco}
                                                        </Typography>

                                                        <Box
                                                            component="button"
                                                            className={`${
                                                                classes.statusButton
                                                            } ${pegarStatusClass(
                                                                servicoPainel.tituloBotao
                                                            )}`}
                                                        >
                                                            {servicoPainel.tituloBotao}
                                                        </Box>
                                                    </Box>
                                                </CardActionArea>
                                            </Card>
                                        </Fade>
                                    </Grid>
                                )
                        )}
                </Grid>
            </Container>

            <Dialog
                open={contratar === "" ? false : true}
                onClose={() => {
                    setContratar("")
                }}
            >
                <DialogTitle>{"Contato para Contratar"}</DialogTitle>
                <DialogContent>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Button
                                onClick={() => {
                                    window.open(
                                        `https://api.whatsapp.com/send?phone=5531994754366&text=Oi%20tudo%20bem?%20Gostaria%20de%20saber%20como%20funciona%20o%20${contratar}%20para%20contratar.`,
                                        "_blank"
                                    )
                                    setContratar("")
                                }}
                                style={{ backgroundColor: "#075E54", color: "white" }}
                                fullWidth
                                variant="contained"
                            >
                                Contactar por Whatsapp
                            </Button>
                        </Col>
                        <Col xs={12} md={12} lg={12}>
                            <Button
                                onClick={() => {
                                    setContratar("")
                                }}
                                fullWidth
                                style={{ marginTop: "1em" }}
                            >
                                Não quero
                            </Button>
                        </Col>
                    </Row>
                </DialogContent>
            </Dialog>

            {help.id && (
                <Dialog
                    fullScreen
                    open={!!help.id}
                    onClose={handleNotHelp}
                    TransitionComponent={Transition}
                >
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleNotHelp}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                {help.nome}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Container className={classes.appContainer}>
                        <Row>
                            <Col
                                xs={12}
                                md={12}
                                lg={12}
                                style={{ marginTop: "5em", textAlign: "center" }}
                            >
                                {help.linkTutorial.map(tutorial => (
                                    <>
                                        <Typography variant="h6" className={classes.title}>
                                            {tutorial.nome}
                                        </Typography>
                                        <iframe
                                            width="100%"
                                            height="400"
                                            src={tutorial.url}
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen
                                        ></iframe>
                                        <Divider></Divider>
                                    </>
                                ))}
                            </Col>
                        </Row>
                    </Container>
                </Dialog>
            )}
        </Box>
    )
}
